// Components
import FormSidePanel from '../FormSidePanel/FormSidePanel';
import FormContent from '../../organisms/FormContent/FormContent';

// Domain
import { getFormPanelTitle } from '../../../domain/form/formUseCase';
import { hasFormLiveSearch } from '../../../domain/live-search/liveSearchUseCase';

// Services
import { useFormConfig } from '../../../services/forms/formQueries';

/**
 * Single layer of the form side panel stack.
 * @param {object} props
 * @param {string} props.formUrl - Form URL from API or page action
 * @param {string} props.containerId - Scroll container id for FormTabs
 * @param {number} props.stackDepth - Depth in the panel stack (0 = root)
 * @param {boolean} props.isOpen - Whether this layer is visible
 * @param {boolean} props.showBackdrop - Whether to show the closing backdrop
 * @param {() => void} [props.onClose] - Close handler (header, backdrop, escape); omitted when not the top layer
 * @param {() => void} props.onExitComplete - Called after the slide-out animation ends
 * @param {(fieldsToUpdate?: ApiFormFieldsToUpdateItem[]) => void} props.onCloseAfterSuccess - Close after successful submit
 * @returns {JSX.Element} FormPanelLayer component
 */
function FormPanelLayer({
  formUrl,
  containerId,
  stackDepth,
  isOpen,
  showBackdrop,
  onClose,
  onExitComplete,
  onCloseAfterSuccess,
}) {
  const { data: formConfig, isLoading: isFormConfigLoading } = useFormConfig(formUrl, {});
  const formPanelTitle = getFormPanelTitle(formConfig);

  return (
    <FormSidePanel
      isOpen={isOpen}
      title={formPanelTitle}
      containerId={containerId}
      hasLiveSearch={hasFormLiveSearch(formConfig)}
      onClose={onClose}
      onExitComplete={onExitComplete}
      stackDepth={stackDepth}
      showBackdrop={showBackdrop}
    >
      <FormContent
        formConfig={formConfig}
        isLoading={isFormConfigLoading}
        onCloseAfterSuccess={onCloseAfterSuccess}
        containerId={containerId}
      />
    </FormSidePanel>
  );
}

export default FormPanelLayer;
